import PropTypes from 'prop-types';
import React, { Component } from 'react';
import injectSheet from 'react-jss';

import ActionsMenu from '~/components/Shared/ActionsMenu/ActionsMenu';
import EcFilterInput from '~/components/Shared/EcFilterInput/EcFilterInput';
import { Button } from '~/eds/src/components/Button/Button';
import { FormattedMessage, injectIntl } from 'react-intl';

import { MODAL_DELETE, MODAL_NAME } from '../../../types/modal.types';
import { ERROR, SUCCESS } from '../../../types/toast.types';
import {
  deleteDocumentsViewset,
  editDocumentsViewset,
  getDocumentsViewsets,
} from '../../DocumentsViewPage/Document.data';
import EcModal from '../../Shared/EcModal/EcModal';
import EcModalCard from '../../Shared/EcModalCard/EcModalCard';
import { showToast } from '../../Shared/EcToast/showToast';
import CheckmarkIcon from '../../Shared/Icons/CheckmarkIcon';
import styles from './DocumentsColumnFieldsViewSwitchModal.styles';

class DocumentsColumnFieldsViewSwitchModal extends Component {
  constructor(props) {
    super(props);

    this.handleHideModal = this.handleHideModal.bind(this);
    this.handleViewSearch = this.handleViewSearch.bind(this);
    this.handleRenameView = this.handleRenameView.bind(this);

    this.state = {
      views: [],
      filteredViews: [],
      filtering: false,
    };
  }

  componentDidMount() {
    this.getDocumentsViewsets();
  }

  getDocumentsViewsets() {
    const { context, intl } = this.props;
    getDocumentsViewsets({ params: { context } })
      .then((data) => {
        this.setState({ views: data });
      })
      .catch(() => {
        this.setState({ errorLoading: true });
        showToast(
          ERROR,
          intl.formatMessage({
            id: 'DocumentsColumnFieldsViewSwitchModal.loadError',
            defaultMessage: 'An error occurred while loading view list.',
            description: 'Error message when loading views fails',
          }),
        );
      });
  }

  getMenuItems = (item) => {
    const { intl } = this.props;
    const items = [];

    items.push(
      {
        content: intl.formatMessage({
          id: 'DocumentsColumnFieldsViewSwitchModal.renameMenuItem',
          defaultMessage: 'Rename',
          description: 'Menu item for renaming view',
        }),
        onClick: () => this.handleShowModal(MODAL_NAME, item),
      },
      {
        content: intl.formatMessage({
          id: 'DocumentsColumnFieldsViewSwitchModal.deleteMenuItem',
          defaultMessage: 'Delete',
          description: 'Menu item for deleting view',
        }),
        onClick: () => this.handleShowModal(MODAL_DELETE, item),
      },
    );

    return items;
  };

  handleViewSearch(filterValue) {
    const { views } = this.state;
    const filteredViews = views.filter((view) =>
      view.name.toLowerCase().includes(filterValue),
    );

    this.setState({ filteredViews, filterValue, filtering: true });

    if (!filterValue) {
      this.setState({ views, filtering: false });
    }
  }

  handleRenameView(newName) {
    const { selectedItem } = this.state;
    const { intl } = this.props;

    editDocumentsViewset(selectedItem.id, newName)
      .then((res) => {
        this.handleHideModal();
        showToast(
          SUCCESS,
          intl.formatMessage(
            {
              id: 'DocumentsColumnFieldsViewSwitchModal.renameSuccess',
              defaultMessage:
                '"{oldName}" view has been renamed to "{newName}".',
              description:
                'Success message for view rename. Example: oldName = "Old Contract View", newName = "New Contract View"',
            },
            {
              oldName: selectedItem.name,
              newName: res.name,
            },
          ),
        );
        this.getDocumentsViewsets();
      })
      .catch(() => {
        this.handleHideModal();
        showToast(
          ERROR,
          intl.formatMessage({
            id: 'DocumentsColumnFieldsViewSwitchModal.renameError',
            defaultMessage: 'An error occurred while renaming view.',
            description: 'Error message for view rename failure',
          }),
        );
      });
  }

  handleDeleteView(viewId) {
    const { intl } = this.props;

    deleteDocumentsViewset(viewId)
      .then((res) => {
        this.handleHideModal();
        showToast(
          SUCCESS,
          intl.formatMessage(
            {
              id: 'DocumentsColumnFieldsViewSwitchModal.deleteSuccess',
              defaultMessage: '"{name}" view has been deleted.',
              description:
                'Success message for view deletion. Example: name = "Contract Analysis View"',
            },
            {
              name: res.name,
            },
          ),
        );
        this.getDocumentsViewsets();
      })
      .catch(() => {
        this.handleHideModal();
        showToast(
          ERROR,
          intl.formatMessage({
            id: 'DocumentsColumnFieldsViewSwitchModal.deleteError',
            defaultMessage: 'An error occurred while deleting the view.',
            description: 'Error message for view deletion failure',
          }),
        );
      });
  }

  handleShowModal(modal, selectedItem = null) {
    this.setState({
      primaryModal: modal,
      selectedItem: selectedItem,
    });
  }

  handleHideModal() {
    this.setState({ primaryModal: null, selectedItem: null });
  }

  renderNameModal() {
    const { selectedItem } = this.state;
    const { intl } = this.props;

    return (
      <EcModal
        modalType={MODAL_NAME}
        width="560px"
        title={intl.formatMessage({
          id: 'DocumentsColumnFieldsViewSwitchModal.renameModalTitle',
          defaultMessage: 'Rename View',
          description: 'Title for rename view modal',
        })}
        labelText={intl.formatMessage({
          id: 'DocumentsColumnFieldsViewSwitchModal.viewNameLabel',
          defaultMessage: 'VIEW NAME',
          description: 'Label for view name field',
        })}
        itemsCurrentName={selectedItem.name}
        confirmButtonIcon={<CheckmarkIcon size="20" color="#fff" />}
        confirmButtonText={intl.formatMessage({
          id: 'DocumentsColumnFieldsViewSwitchModal.renameButton',
          defaultMessage: 'Rename',
          description: 'Rename button text',
        })}
        handleNameChange={this.handleRenameView}
        hideModal={this.handleHideModal}
      />
    );
  }

  renderDeleteViewModalText() {
    return (
      <FormattedMessage
        id="DocumentsColumnFieldsViewSwitchModal.deleteConfirmation"
        defaultMessage="Are you sure you want to delete <span>{viewName}</span>? You won't be able to undo this action."
        description="Confirmation message for deleting view. Example: viewName = 'Monthly Reports View'"
        values={{
          viewName: this.state.selectedItem.name,
          span: (chunks) => <span> {chunks} </span>,
        }}
      />
    );
  }

  renderDeleteModal() {
    const { selectedItem } = this.state;
    const { intl } = this.props;

    return (
      <EcModal
        modalType={MODAL_DELETE}
        width="560px"
        title={intl.formatMessage({
          id: 'DocumentsColumnFieldsViewSwitchModal.deleteModalTitle',
          defaultMessage: 'Delete View?',
          description: 'Title for delete view modal',
        })}
        text={this.renderDeleteViewModalText()}
        confirmButtonText={intl.formatMessage({
          id: 'DocumentsColumnFieldsViewSwitchModal.deleteButton',
          defaultMessage: 'Delete',
          description: 'Delete button text',
        })}
        deleteItem={() => this.handleDeleteView(selectedItem.id)}
        hideModal={this.handleHideModal}
      />
    );
  }

  renderSearchBox() {
    const { classes, intl } = this.props;
    const { filterValue } = this.state;

    return (
      <div className={classes.searchboxContainer}>
        <div className={classes.filterSearch}>
          <EcFilterInput
            value={filterValue}
            onChange={(filterValue) => this.handleViewSearch(filterValue)}
            onClearSearch={() => this.handleViewSearch('')}
            placeholder={intl.formatMessage({
              id: 'DocumentsColumnFieldsViewSwitchModal.filterPlaceholder',
              defaultMessage: 'Filter saved views...',
              description: 'Placeholder text for filter input',
            })}
          />
        </div>
      </div>
    );
  }

  renderDefaultView() {
    const { classes, handleApplyDefaultViewClick, intl } = this.props;
    const { filtering } = this.state;

    if (filtering) return null;

    return (
      <div className={classes.itemRow} role="listitem">
        <div className={classes.itemName}>
          <FormattedMessage
            id="DocumentsColumnFieldsViewSwitchModal.defaultView"
            defaultMessage="Default View"
            description="Label for default view option"
          />
        </div>
        <div className={classes.itemActionsDefault}>
          <Button
            text={intl.formatMessage({
              id: 'DocumentsColumnFieldsViewSwitchModal.applyButton',
              defaultMessage: 'Apply',
              description: 'Apply button text',
            })}
            onClick={handleApplyDefaultViewClick}
          />
        </div>
      </div>
    );
  }

  renderItems() {
    const { views, filtering, filteredViews } = this.state;

    const sortedViews = views.length
      ? views.sort((a, b) =>
          a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
        )
      : [];

    if (!sortedViews.length && !filtering) {
      return (
        <div>
          <p>
            <FormattedMessage
              id="DocumentsColumnFieldsViewSwitchModal.noViews"
              defaultMessage="You currently have no saved views."
              description="Message when no saved views exist"
            />
          </p>
        </div>
      );
    } else if (filtering) {
      if (!filteredViews.length) {
        return (
          <div>
            <p>
              <FormattedMessage
                id="DocumentsColumnFieldsViewSwitchModal.noMatchingViews"
                defaultMessage="No views match your filter."
                description="Message when filter returns no results"
              />
            </p>
          </div>
        );
      }
      return this.renderList(filteredViews);
    }
    return this.renderList(sortedViews);
  }

  renderList(list) {
    const { classes, handleApplyViewClick, intl } = this.props;
    return list.map((item) => {
      return (
        <div className={classes.itemRow} key={item.id} role="listitem">
          <div className={classes.itemName}>{item.name}</div>
          <div className={classes.itemActions}>
            <Button
              text={intl.formatMessage({
                id: 'DocumentsColumnFieldsViewSwitchModal.applyButton',
                defaultMessage: 'Apply',
                description: 'Apply button text',
              })}
              onClick={() => handleApplyViewClick(item.id)}
            />
            <div className={classes.actionsWrapper}>
              <ActionsMenu
                id={`documents_column_fields_view_switch_actions_menu?${item.type}=${item.id}`}
                items={this.getMenuItems(item)}
                align="end"
                title={intl.formatMessage({
                  id: 'DocumentsColumnFieldsViewSwitchModal.actionsMenuTitle',
                  defaultMessage:
                    'documents column fields view switch actions menu',
                  description: 'Title for actions menu',
                })}
              />
            </div>
          </div>
        </div>
      );
    });
  }

  render() {
    const { classes, hideModal, intl } = this.props;
    const { primaryModal } = this.state;

    return (
      <>
        <EcModalCard
          title={intl.formatMessage({
            id: 'DocumentsColumnFieldsViewSwitchModal.title',
            defaultMessage: 'Saved Views',
            description: 'Title for saved views modal',
          })}
          content={
            <div className={classes.modalBody}>
              <div className={classes.modalBodyContent} role="group">
                {this.renderSearchBox()}
                {this.renderDefaultView()}
                {this.renderItems()}
              </div>
            </div>
          }
          hideModal={hideModal}
        />
        {primaryModal === MODAL_NAME ? this.renderNameModal() : null}
        {primaryModal === MODAL_DELETE ? this.renderDeleteModal() : null}
      </>
    );
  }
}

DocumentsColumnFieldsViewSwitchModal.propTypes = {
  handleApplyDefaultViewClick: PropTypes.func.isRequired,
  handleApplyViewClick: PropTypes.func.isRequired,
  handleRenameView: PropTypes.func,
  handleDeleteView: PropTypes.func,
  hideModal: PropTypes.func.isRequired,
};

export default injectIntl(
  injectSheet(styles)(DocumentsColumnFieldsViewSwitchModal),
);
